export const appConfig =  {
    productionMode:true,
    showcountryList:true,
    staticPages:true,
    mobileLogin:true,
    facebookLogin:true,
    appleLogin:true,
    defaultMode: 'News'
};